<template>
    <mm-tab-title v-model="tab" :titles="titles">
                <el-button v-show="tab===1" slot="save" size="medium" type="primary" @click="submit">save</el-button>

            <div v-show="tab===1">
                <el-form ref="form" :model="result" size="small" label-width="200px">
                    <el-form-item label="Period">
                        <el-input :value="result.period" readonly />
                    </el-form-item>
                    <el-form-item label="Adv Name">
                        <el-input v-model="result.adv_name" readonly />
                    </el-form-item>
                    <el-form-item label="Offer Id">
                        <el-input v-model="result.offer_id" readonly />
                    </el-form-item>
                    <el-form-item label="Offer Name">
                        <el-input v-model="result.offer_name" readonly />
                    </el-form-item>
                    <el-form-item label="Adv Offer Id">
                        <el-input v-model="result.adv_offer_id" readonly />
                    </el-form-item>
                    <el-form-item label="Package Id">
                        <el-input v-model="result.package_id" readonly />
                    </el-form-item>
                    <el-form-item label="Offer Revenue">
                        <mm-number-input v-model="result.snt_offer_rev" />
                    </el-form-item>
                    <el-form-item label="Amount">
                        <mm-number-input v-model="result.amount" />
                    </el-form-item>
                    <el-form-item label="Amount Percent">
                        <span>{{ result.snt_offer_rev && result.amount && (result.amount / result.snt_offer_rev * 100).toFixed(2) + '%' || '--' }}</span>
                    </el-form-item>
                    <el-form-item label="Amount Reason">
                        <mm-amount-reason v-model="result.amount_reason" />
                    </el-form-item>
                    <el-form-item label="Status">
                        <mm-offer-amount-status v-model="result.status" />
						<el-date-picker v-if="showChargebackTime" v-model="result.chargeback" type="month" placeholder="Select"/>
                    </el-form-item>
                    <el-form-item label="Remark" prop="remark">
                        <el-input v-model="result.remark" type="textarea" :rows="5" />
                    </el-form-item>
                </el-form>

            </div>
            <div v-show="tab===2">
                <div style="display: flex;">
                    <mm-lc title="Channel">
                        <mm-channel-select v-model="where.channel_id" multiple />
                    </mm-lc>
                    <mm-lc title="Amount Status">
                        <mm-offer-amount-status v-model="where.status" multiple isChannel />
                    </mm-lc>
                </div>
                <div class="channel-offer-list">
                    <channel-offer-list ref="col" inAdvOffer :where="{time:result.time, offer_id:result.offer_id, channel_id: where.channel_id, status: where.status}" />
                </div>
            </div>
    </mm-tab-title>

</template>

<script>
import ChannelOfferList from "./ChannelMmpOfferList";
export default {
	watch: {
		$route(to, from) {
			this.loadData();
		},
		'result.status'(status) {
			if (status === 'chargeback') {
				this.showChargebackTime = true;
			} else {
				this.showChargebackTime = false;
			}
		},
	},
	data() {
		return {
			result: {},
			file_list: [],
			tab: 1,
			titles: ["Base Info", "Detail"],
			where: {},
			showChargebackTime: false,
		};
	},
	methods: {
		async submit() {
			if (this.result.status === 'chargeback') {
				if (!this.result.chargeback) {
					this.$message({
						type: 'error',
						message: 'Missing Chargeback Time',
					});
					return;
				}
			} else {
				this.result.chargeback = '';
			}
			if (this.result.chargeback && !/[0-9]{4}-[0-9]{2}/.test(this.result.chargeback)) {
				this.result.chargeback = this.$utils.date_format(this.result.chargeback, 'YYYY-MM');
			}
			const request_path = "/advMmpOffer/update";
			const result = await this.$post(request_path, this.result);
			await this.$refs.col.refresh();
			this.loadData();
		},
		async loadData() {
			const id = this.$route.query["id"];
			this.result = await this.$post("/advMmpOffer/detail", { id: id });
		}
	},
	components: {
		"channel-offer-list": ChannelOfferList
	},

	beforeMount() {
		this.loadData();
	}
};
</script>
<style scoped>
.channel-offer-list{
    overflow: hidden;
    height: 650px;
}
</style>
